module.exports = "/static/videos/lake-2024.mp4";